import type { CreatorType, UploadFileStatusEnum } from '@shared/api';

export const EVENT_MESSAGES = {
  CONNECTED: 'CONNECTED',
  AUTHORIZED: 'AUTHORIZED',
  FAILED_AUTHORIZATION: 'FAILED_AUTHORIZATION',
  PING: 'PING',
  PONG: 'PONG',
};

type ChatMessagePayload = {
  channel_id: number;
  client_id: number;
  client_name?: string | null;
  organization_id?: number | null;
  created_at: string;
  creator_type: CreatorType;
  message: string;
  message_id: number;
  manager_delta: number;
  client_avatar_url: string;
  switched_agent_id?: number | null;
  is_form_shown: boolean;
};

type ChannelDeactivatedPayload = {
  channel_id: number;
  channel_name: string;
  is_active: boolean;
  reason: string;
};

type ClientFieldsChangedPayload = {
  client_id: number;
  fields: Array<{
    agent_field_id: number;
    value: string;
  }>;
};

type ChangeCurrentAgentPayload = {
  client_id: number;
  current_agent_id: number;
};

type FormShownPayload = {
  client_id: number;
  message_id: number;
};

type LeadCreatedPayload = {
  client_id: number;
  lead_created_at: string;
};

type KnowledgeStatusUpdatedPayload = {
  knowledge_base_id: number;
  status: UploadFileStatusEnum;
};

type PreviewGeneratedPayload = {
  id: number;
  url: string;
  question: string;
  answers: string[];
};

type AgentTestStreamMessagePayload = {
  message_request_id: number;
  message_part: string;
};

type AgentTestMessagePayload = {
  message_id: number;
  message: string;
  recommendations: string[];
  agent_id?: number | string;
  message_request_id?: number;
  request_id?: number;
  creator_type?: CreatorType;
  created_at?: string;
  switched_agent_id?: number | null;
};

type AgentTestFieldsChangedPayload = {
  agent_id: number | string;
  fields: Array<{
    agent_field_id: number;
    value: string;
  }>;
  created_at?: string;
};

type AgentTestSwitchAgentPayload = {
  agent_id: number | string;
  new_agent_id: number | string;
  new_agent_name?: string;
  message_id?: number;
};

export type EventPayloadByName = {
  CHAT_MESSAGE: ChatMessagePayload;
  CHANNEL_DEACTIVATED: ChannelDeactivatedPayload;
  CLIENT_FIELDS_CHANGED: ClientFieldsChangedPayload;
  CHANGE_CURRENT_AGENT: ChangeCurrentAgentPayload;
  FORM_SHOWN: FormShownPayload;
  LEAD_CREATED: LeadCreatedPayload;
  KNOWLEDGE_STATUS: KnowledgeStatusUpdatedPayload;
  PREVIEW_GENERATED: PreviewGeneratedPayload;
  AGENT_TEST_STREAM_MESSAGE: AgentTestStreamMessagePayload;
  AGENT_TEST_MESSAGE: AgentTestMessagePayload;
  AGENT_TEST_FIELDS_CHANGED: AgentTestFieldsChangedPayload;
  AGENT_TEST_SWITCH_AGENT: AgentTestSwitchAgentPayload;
};

export type EventName = keyof EventPayloadByName;
